import { render, staticRenderFns } from "./Activos.vue?vue&type=template&id=5690abe3&"
import script from "./Activos.vue?vue&type=script&lang=ts&"
export * from "./Activos.vue?vue&type=script&lang=ts&"
import style0 from "./Activos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5690abe3', component.options)
    } else {
      api.reload('5690abe3', component.options)
    }
    module.hot.accept("./Activos.vue?vue&type=template&id=5690abe3&", function () {
      api.rerender('5690abe3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/modal-altas/Activos.vue"
export default component.exports